<script setup>

import { ref, computed } from 'vue';
import IndexHeader from './Articles/components/IndexHeader.vue';
import IndexCard from './Articles/components/IndexCard.vue';
import IndexHighlightCard from './Articles/components/IndexHighlightCard.vue';
import IndexFilter from './Articles/components/IndexFilter.vue';

const props = defineProps({
    title: {
        type: String,
        required: true
    },
    articles: {
        type: Array,
        required: true
    },
    highlightedPost: {
        type: Object,
        default: () => ({})
    },
    articleFilters: {
        type: Object,
        default: () => []
    },
    selectedFilters: {
        type: Object,
        default: () => ({})
    }
})

// const articles = ref(props.articles);

const highlightedPost = ref(props.highlightedPost);

const title = ref(props.title);

const articleFilters = ref(props.articleFilters);

const selectedFilters = ref(props.selectedFilters);

for (const [key, value] of Object.entries(articleFilters.value)) {
    selectedFilters.value[key] = [];
}

const filteredArticles = computed(() => {
    return props.articles.filter((article) => {
        const selectedTermsArray = Object.entries(selectedFilters.value).flatMap(([type, items]) =>
            items.map((item) => ({ type, item }))
        );

        if (article.ID === highlightedPost.value.ID && selectedTermsArray.length === 0) {
            return false;
        }


        if (selectedTermsArray.length === 0) {
            return true;
        }

        return (
            article.phases.some((phase) =>
                selectedTermsArray.some(
                    (selectedTerm) => selectedTerm.type === "phases" && selectedTerm.item.name === phase
                )
            ) ||
            article.themes.some((theme) =>
                selectedTermsArray.some(
                    (selectedTerm) => selectedTerm.type === "themes" && selectedTerm.item.name === theme
                )
            ) ||
            article.programmes.some((programme) =>
                selectedTermsArray.some(
                    (selectedTerm) => selectedTerm.type === "programmes" && selectedTerm.item.name === programme
                )
            )
        );
    });
});

</script>

<template>

    <IndexHeader :title="title" />

    <IndexFilter :articleFilters="articleFilters" v-model:selectedFilters="selectedFilters" />

    <IndexHighlightCard v-if="Object.values(selectedFilters).every(arr => arr.length === 0)"
        :highlightedPost="highlightedPost" />

    <section class="section m-listing-articles">
        <div class="m-listing-articles__cards">
            <div class="articles-wrapper">
                <template v-if="filteredArticles.length > 0">
                    <IndexCard :key="article.id" :article="article" v-for="article in filteredArticles" />
                </template>
                <template v-else>
                    <p>Geen artikelen gevonden. Probeer een andere zoekopdracht</p>
                </template>
            </div>
        </div>
    </section>
</template>